import { escapeHtml } from '@/utils/html';
import { splitLatex } from '@/utils/latexScanner';

const LATEX_REGEX = /\\[a-zA-Z]+|[\^_]\{/;

export const hasLatex = (text: string): boolean => LATEX_REGEX.test(text);

const loadKatex = async () => {
  const [{ default: katex }] = await Promise.all([
    import('katex'),
    import('katex/dist/katex.min.css'),
  ]);

  return katex;
};

export const renderLatex = async (
  text: string,
): Promise<string | undefined> => {
  try {
    const katex = await loadKatex();

    return splitLatex(text)
      .map(({ value, isMath }) => {
        if (!isMath) {
          return escapeHtml(value);
        }

        try {
          return katex.renderToString(`\\displaystyle ${value}`, {
            throwOnError: true,
            strict: 'ignore',
          });
        } catch {
          return escapeHtml(value);
        }
      })
      .join('');
  } catch {
    return undefined;
  }
};
